import { Link } from "react-router-dom";
import { ChatCircleDots, ArrowRight } from "@phosphor-icons/react";

/**
 * Shown when a user navigates to /inbox but the Chatwoot app
 * is not installed on their tenant. Replaces the silent redirect
 * to /apps with a clear install CTA.
 */
export function InboxNotInstalledFallback() {
  return (
    <div className="flex items-center justify-center min-h-[60vh] px-4">
      <div className="text-center max-w-sm space-y-4">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-blue-500/10 flex items-center justify-center">
          <ChatCircleDots size={32} weight="fill" className="text-blue-500" />
        </div>
        <h2 className="text-lg font-semibold text-foreground">
          ติดตั้งระบบ Inbox ก่อนใช้งาน
        </h2>
        <p className="text-sm text-muted-foreground">
          เพิ่มแอป Inbox เพื่อเชื่อมต่อช่องทางแชทและรับข้อความจากลูกค้า
        </p>
        <Link
          to="/apps"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-blue-500 text-white text-sm font-medium hover:bg-blue-600 transition-colors"
        >
          ไปหน้า Marketplace
          <ArrowRight size={16} weight="bold" />
        </Link>
      </div>
    </div>
  );
}
